import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../../appTheme";


export const sortOptionListStyle = StyleSheet.create({
    parent: {
        flex: 1,
        backgroundColor: '#F8FAFC'
    },
    saveTxt: {
        fontSize: fontSize.smallFontSize,
        color: appColors.light,
        fontFamily: appFonts.bold
    },
    saveCon: {
        backgroundColor: appColors.primary,
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 8
    },
    itemCon: {
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 18,
        paddingVertical: 14,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F5F9',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    itemConActive: {
        backgroundColor: '#EFF6FF',
        borderColor: appColors.primary,
        borderWidth: 1.5,
        borderRadius: 10,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 6 },
        shadowOpacity: 0.12,
        shadowRadius: 10,
        elevation: 6
    },
    loadCon: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: appColors.transparent
    },
    cardWrapper: {
        flex: 1,
        backgroundColor: '#FFFFFF',
        borderRadius: 14,
        borderWidth: 1,
        borderColor: '#E2E8F0',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.04,
        shadowRadius: 4,
        elevation: 1,
        overflow: 'hidden'
    },
    cardHeader: {
        paddingHorizontal: 20,
        paddingVertical: 16,
        borderBottomWidth: 1,
        borderBottomColor: '#E2E8F0',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF'
    },
    infoIconCircle: {
        width: 38,
        height: 38,
        borderRadius: 19,
        backgroundColor: '#EAF6F8',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 12
    },
    indexBadge: {
        width: 28,
        height: 28,
        borderRadius: 14,
        backgroundColor: '#F1F5F9',
        justifyContent: 'center',
        alignItems: 'center'
    },
    dragHandle: {
        width: 36,
        height: 36,
        borderRadius: 8,
        backgroundColor: '#F8FAFC',
        borderWidth: 1,
        borderColor: '#E2E8F0',
        justifyContent: 'center',
        alignItems: 'center'
    }
})